<style lang="scss" scoped>
.baseWarnWrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.8);
  z-index: 4;
}
.baseWarn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: white;
  border: 1px solid #ff0404;
  width: 400px;
  height: 420px;
}
.header {
  background-color: #fe6868;
  color: white;
  text-align: center;
  height: 77px;
  line-height: 77px;

  img {
    width: 30px;
    height: 30px;
    transform: translateX(-5px) translateY(5px);
  }
  font-size: 22px;
}
.content {
  p:nth-of-type(1) {
    color: #fe6868;
    margin-top: 80px;
    text-align: center;
    font-size: 22px;
  }
  .second {
    color: #fe6868;
  }
  p:nth-of-type(2) {
    margin-bottom: 30px;
  }
}
.footer{
  padding: 0 20px;
  line-height: 20px;
}
.body{
  padding: 0 20px;
  line-height: 26px;
}

</style>
<template>
  <div v-show="showWarn" class="baseWarnWrapper">
    <div class="baseWarn">
      <div class="header">
        <img src="../assets/images/warn.png" alt />
        {{warnCount? `第${warnCount}次警告` : '警告'}}
      </div>
      <div class="content">
        <p class="body">{{tips.body}}</p>
        <p class="footer">{{tips.footer}}</p>
        <!-- <p>
          <span class="second">{{countDown}}s</span>后自动关闭
        </p> -->
      </div>
      <div class="close">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // countDown: 5,
      // timer: null,
    };
  },
  methods: {
    handleClose() {
      this.$emit('update:showWarn', false);
    },
  },
  components: {},
  created() {},
  mounted() {},
  props: {
    showWarn: {
      type: Boolean,
    },
    warnCount: {
      type: Number,
    },
    warnType: {
      type: Number,
    },
    warnContent: {
      type: String,
    },
  },
  watch: {
    showWarn(val) {
      // if (val) {
      //   this.countDown = 5;
      //   this.timer = setInterval(() => {
      //     if (this.countDown > 0) {
      //       this.countDown -= 1;
      //     } else {
      //       this.$emit('update:showWarn', false);
      //       clearInterval(this.timer);
      //       this.timer = null;
      //     }
      //   }, 1000);
      // }
    },
  },
  computed: {
    tips() {
      if (this.warnType === 2) { //实时检测
        return {
          body: this.warnContent,
        };
      }
      if (this.warnCount < 3) {
         switch (this.warnType) {
          case 1: //切屏
            return {
              body: '当前正在考试中，请不要切屏！',
              footer: '被警告超过5次，您将可能被取消您本次考试成绩并禁赛1年！',
            };
          case 3: //离线
            return {
              body: '离线时间过长，请遵守考试规则，否则将会被取消考试资格！',
              footer: '被警告超过3次，您将可能被取消您本次考试成绩并禁赛1年！',
            };
          default:
            return {
              body: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
        }
      }
      if (this.warnCount === 3) {
        switch (this.warnType) {
          case 1: //切屏
            return {
              body: '当前正在考试中，请不要切屏！',
              footer: '被警告超过5次，您将可能被取消您本次考试成绩并禁赛1年！',
              // body: `系统检测您已违规切屏${this.warnCount}次`,
              // footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
          case 3: //离线
            return {
              body: `系统检测您已违规离线${this.warnCount}次`,
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
          default:
            return {
              body: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
        }
      }
      if (this.warnCount > 3 && this.warnCount < 5) {
         switch (this.warnType) {
          case 1: //切屏
            return {
              body: '当前正在考试中，请不要切屏！',
              footer: '被警告超过5次，您将可能被取消您本次考试成绩并禁赛1年！',
              // body: `系统检测您已违规切屏${this.warnCount}次`,
              // footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
          case 3: //离线
            return {
              body: `系统检测您当前为第${this.warnCount}次违规离线`,
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
          default:
            return {
              body: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
        }
      }
      if (this.warnCount >= 5) {
        switch (this.warnType) {
          case 1: //切屏
            return {
              body: `系统检测您已违规切屏${this.warnCount}次`,
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
          case 3: //离线
            return {
              body: `系统检测您当前为第${this.warnCount}次违规离线`,
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
          default:
            return {
              body: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
              footer: '您可以选择继续完成考试，考试结束后若核实违规属实，则将取消您本次考试成绩并禁赛1年！',
            };
        }
      }
    return {};
    },
  },
};
</script>
